import { render } from "./ActivityCenterPreferences.vue?vue&type=template&id=dd4d81c8&scoped=true"
import script from "./ActivityCenterPreferences.vue?vue&type=script&lang=js"
export * from "./ActivityCenterPreferences.vue?vue&type=script&lang=js"

import "./ActivityCenterPreferences.vue?vue&type=style&index=0&id=dd4d81c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd4d81c8"]])

export default __exports__